import React, { FunctionComponent } from 'react';
import Head from 'next/head';
import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import SignInPage from '@/components/pageComponents/SignInPage';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import ProtectedPage from '@/components/navigation/ProtectedPage';

interface IProps {}

const LogIn: FunctionComponent<IProps> = () => (
  <BarHeaderLayout>
    <Head>
      <title>Moment - Log In</title>
      <link rel="canonical" href="/users/sign-up" key="canonical" />
    </Head>
    <ProtectedPage type="lax">
      <SignInPage />
    </ProtectedPage>
  </BarHeaderLayout>
);

export async function getStaticProps() {
  return packageStaticProps({});
}

export default LogIn;
